import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import MixedCopy from '../mixed-copy/mixedCopy';
import Headline from '../../atoms/headline/headline';
import StyledSponsorBanner from './sponsorBanner.style';
import SponsorIcon from '../../icons/hearth.svg';

const SponsorBanner = ({ sponsorText, linkTo, linkText }) => {
  return (
    <StyledSponsorBanner>
      <MixedCopy className="sponsor-banner__sponsor-text" html={sponsorText} />

      <Link className="sponsor-banner__link-text" href={linkTo?.url} aria-label="Sponsor">
        <SponsorIcon />
        <Headline tag="h3">{linkText}</Headline>
      </Link>
    </StyledSponsorBanner>
  );
};

SponsorBanner.propTypes = {
  __typename: PropTypes.string.isRequired,
  sponsorText: PropTypes.string,
  linkTo: PropTypes.shape(),
  linkText: PropTypes.string
};

export default SponsorBanner;
